(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDeleteController',DinghyDeleteController);

    DinghyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dinghy'];

    function DinghyDeleteController($uibModalInstance, entity, Dinghy) {
        var vm = this;

        vm.dinghy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dinghy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
